import { render, staticRenderFns } from "./DailyProofWork.vue?vue&type=template&id=300edc7a"
import script from "./DailyProofWork.vue?vue&type=script&lang=js"
export * from "./DailyProofWork.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports